import React, { Component } from "react";
import Fade from "react-reveal/Fade";

import startCircle from "../../assets/img/learning/first.svg";
import repeatCircle from "../../assets/img/learning/repeat.svg";
import endCircle from "../../assets/img/learning/end.svg";

import SectionTitle from "../SectionTitle/SectionTitle";
import "./LearningPath.css";

const circles = [
  {
    img: startCircle,
    title: "الإندماج"
  },
  {
    img: repeatCircle,
    title: "الإستكشاف"
  },
  {
    img: repeatCircle,
    title: "الفهم"
  },
  {
    img: repeatCircle,
    title: "التطبيق"
  },
  {
    img: endCircle,
    title: "التقييم"
  }
];

export default class LearningPath extends Component {
  render() {
    return (
      <section id="learninig" className="section">
        <Fade duration={1000} delay={200}>
          <SectionTitle>رحلة التعلم</SectionTitle>
        </Fade>

        <div className="learning-container mt-5">
          <div className="columns is-gapless">
            {circles.map((circle, i) => {
              return (
                <Fade duration={1000} delay={200} key={i}>
                  <div className="colmun is-2 learning-circles">
                    <img src={circle.img} alt="" />
                    <p>{circle.title}</p>
                  </div>
                </Fade>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}
